import { render, staticRenderFns } from "./Security.vue?vue&type=template&id=48c0102c&scoped=true&"
import script from "./Security.vue?vue&type=script&lang=js&"
export * from "./Security.vue?vue&type=script&lang=js&"
import style0 from "./Security.vue?vue&type=style&index=0&id=48c0102c&prod&lang=css&"
import style1 from "./Security.vue?vue&type=style&index=1&id=48c0102c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c0102c",
  null
  
)

export default component.exports